import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { JourneyCard } from './components/JourneyCard';
import { JOURNEY_STEPS } from './consts';

export const Journey: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.vision_page.journey.eyebrow')}
				heading={translationKey('corgi.vision_page.journey.heading')}
				body={translationKey('corgi.vision_page.journey.body')}
				align="center"
			/>
			<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-qa="vision-journey-grid">
				{JOURNEY_STEPS.map(({ id, ...step }) => (
					<JourneyCard key={id} {...step} />
				))}
			</div>
		</section>
	);
};
